import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { OrgCommonComponentsPageComponent } from "./org-common-components-page.component";

export const orgCommonComponentsPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-org-common-components-page", OrgCommonComponentsPageComponent)
    .atUrl("/about/theme-test/org-common-components")
    .requiresLogin(false)
    .build();
